import RequestClass from '@api/request/RequestClass';
import {API_NAMESPACE} from '@constants/general';
import {METHOD_POST} from '@constants/http';
import type {GetStatsResponse} from '@interfaces/Test';

export async function getStats(testId: string, questionId: number): Promise<GetStatsResponse> {
    return (await new RequestClass(`${API_NAMESPACE}/test/stats`)
        .setParams({testId, questionId})
        .send()) as Promise<GetStatsResponse>;
}

export function updateStats(testId: string, questionId: number, optionId: number) {
    new RequestClass(`${API_NAMESPACE}/test/stats`, METHOD_POST)
        .setParams({testId, questionId, optionId})
        .sendBlind();
}
